// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsListFeature":"wr_a bhv_b","TwoDimsListFeature__item":"wr_b bhv_ux","TwoDimsListFeature__item__text":"wr_c bhv_un"};